// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"c37b027e","787":"c9256fe3","880":"cc7089f7"}[chunkId] + ".chunk.js";
};